import { createContext, useContext, useState } from "react";

const SidebarContext = createContext();

export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider = ({ children }) => {
  const [expansionPath, setExpansionPath] = useState([]);

  return (
    <SidebarContext.Provider value={{ expansionPath, setExpansionPath }}>
      {children}
    </SidebarContext.Provider>
  );
};
